// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Toasted from 'vue-toasted';
import VueMoment from 'vue-moment';
import NProgress from 'nprogress';
import App from './App'
import store from './store';
import router from './router'

import 'bootstrap-vue/dist/bootstrap-vue.css'

//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'

import './custom.scss'

import 'nprogress/nprogress.css'

Vue.use(BootstrapVue);
Vue.use(Toasted);
Vue.use(VueMoment);

Vue.config.productionTip = false

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 2
  });
  return formatter.format(value);
});

//NProgress.configure({ parent: '#app' });

router.beforeEach((to, from, next) => {
  NProgress.start();
  NProgress.set(0.1);
  next();
})

router.afterEach((to, from) => {
  setTimeout(() => NProgress.done(), 500);
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js